import { create } from 'zustand'

import { UserPaginated } from '../hooks/usePaginateUsers'

interface SelectedUserStore {
  user: UserPaginated | null
  setUser: (user: UserPaginated | null) => void
}

export const useSelectedUserStore = create<SelectedUserStore>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
}))
